import { Component, Inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AJSRootScope } from 'ib-web-commons/utils';
import { IbDisruptedSeatsRefundModel } from 'src/app/core/models/disrupted-seats/ib-disrupted-seats-refund-model';
import { RefundsMethod } from '../../../../core/models/disrupted-seats/ib-disrupted-seats-refund-model';
import { newAncillariesConstants } from '../../../../../ib-web-new-ancillaries-constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ib-disrupted-seats-refund-modal',
    templateUrl: './ib-disrupted-seats-refund-modal.component.html',
    styleUrls: ['./ib-disrupted-seats-refund-modal.component.scss']
})
export class IbDisruptedSeatsRefundModalComponent implements OnInit {

    @Input() model: IbDisruptedSeatsRefundModel;
    imgUrl: string = this.$rootScope.routes.images;
    iconUrl: string = this.$rootScope.routes.icons;
    flowId: string;
    headerModel: GenericHeader;
    boxInfoModels: IbBoxInfoModel[] = [];
    cashRefund: RefundsMethod;
    voucherRefund: RefundsMethod;
    translationsMap = new Map<string, string>();

    constructor (
        @Inject(AJSRootScope) private $rootScope: any,
        private activeModal: NgbActiveModal,
        private translate: TranslateService
    ) { }

    ngOnInit (): void {
        this.initTextModels();
        this.getRefundMethods();
    }

    closeModal (): void {
        this.activeModal.close();
    }

    private getRefundMethods () {
        this.cashRefund = this.model?.data.refundsMethods.find(
            (refundMethod: RefundsMethod) => refundMethod.type === newAncillariesConstants.DISRUPTED_SEATS.REFUND_TYPES.CASH
        );
        this.voucherRefund = this.model?.data.refundsMethods.find(
            (refundMethod: RefundsMethod) => refundMethod.type === newAncillariesConstants.DISRUPTED_SEATS.REFUND_TYPES.VOUCHER
        );
    }

    private initTextModels (): void {
        this.headerModel = {
            title: 'SEATS_DISRUPTION',
            closeText:'CANCEL_SPECIAL_NEEDS_MODAL_CHECK_TEXT_2_TITLE',
            steps: {
                activeStep: 1,
                stepNames: ['Reembolso', 'Confirmación']
            }
        };

        const boxInfo1: IbBoxInfoModel = {
            title: 'MMB_DISRUPTION_CALLCENTER_DOUBTS',
            text: 'MMB_DISRUPTION_CALLCENTER_CONTACT_MSG_NO_PHONE'
        };

        this.boxInfoModels.push(boxInfo1);

        const boxInfo2: IbBoxInfoModel = {
            title: 'MMB_REFUNDS_PASSENGER_RIGHTS_TITLE',
            linkText: 'MORE_INFO_LINK'
        };
        this.boxInfoModels.push(boxInfo2);

        this.translationsMap.set('SEATS_DISRUPTION_REFUND_INSTANT', this.translate.instant('SEATS_DISRUPTION_REFUND_INSTANT'));
        this.translationsMap.set('SEATS_DISRUPTION_REFUND_VALID_ONE_YEAR', this.translate.instant('SEATS_DISRUPTION_REFUND_VALID_ONE_YEAR'));
        this.translationsMap.set('SEATS_DISRUPTION_REFUND_ANCILLARIES', this.translate.instant('SEATS_DISRUPTION_REFUND_ANCILLARIES'));
        this.translationsMap.set('SEATS_DISRUPTION_REFUND_A_YEAR_AFTER', this.translate.instant('SEATS_DISRUPTION_REFUND_A_YEAR_AFTER'));
        this.translationsMap.set('SEATS_DISRUPTION_REFUND_USAGES', this.translate.instant('SEATS_DISRUPTION_REFUND_USAGES'));
    }


}
